/**
 * DailyAnchorBanner (P10)
 * ───────────────────────
 * Single-line contextual header rendered at the top of the Contractor Portal
 * Home tab. Pure presentation over `resolveDailyAnchor()` — no logic here.
 */

import type { DailyAnchor, DailyAnchorTone } from "@/data/contractor/dailyAnchor";

const TONE_CLASSES: Record<DailyAnchorTone, string> = {
  // urgent → light warning tint
  urgent: "border-warning/30 bg-warning/10 text-warning-foreground",
  // today → primary tint
  today: "border-primary/30 bg-primary/10 text-foreground",
  // action → amber/warning-leaning tint (distinct from urgent)
  action: "border-warning/20 bg-warning/5 text-foreground",
  // earnings → muted (per approved hierarchy: secondary to today/action)
  earnings: "border-border bg-muted/40 text-muted-foreground",
  // calm → muted
  calm: "border-border bg-muted/30 text-muted-foreground",
};

export function DailyAnchorBanner({ anchor }: { anchor: DailyAnchor }) {
  return (
    <div
      data-testid="daily-anchor"
      data-tone={anchor.tone}
      data-priority={anchor.priority}
      className={`rounded-md border px-3 py-2 text-sm leading-snug ${TONE_CLASSES[anchor.tone]}`}
    >
      <span className="font-medium">{anchor.greeting}</span>
      <span className="opacity-70"> — </span>
      <span>{anchor.message}</span>
    </div>
  );
}
